<template>
  <div
    :class="[$style.config, $style.variant, isActive && $style.activeVariant]"
    data-product-variant-selector-item-v="3.1.0"
  >
    <div :class="$style.imageWrapper">
      <BasePicture
        v-if="variant?.fields?.images?.[0]?.fields?.file?.url"
        :class="$style.picture"
        :img-class="$style.image"
        alt=""
        :src="`${variant?.fields?.images?.[0]?.fields?.file?.url}?w=160&h=160&fit=pad`"
      />
    </div>
    <div :class="$style.name">
      {{ variant?.fields?.type?.fields?.label || variant?.fields?.name || '' }}
    </div>
  </div>
</template>

<script setup lang="ts">
import type { TypeProductWithoutUnresolvableLinksResponse } from '~/types/contentful'

defineProps<{
  variant: TypeProductWithoutUnresolvableLinksResponse
  isActive: boolean
}>()
</script>

<style lang="scss" module>
.config {
  @include breakpoint-variables(
    '--pvsi-image-size',
    (
      base: 100px,
      md: 110px,
    )
  );
}

.variant {
  background-color: var(--white);
  border: 1px solid rgba(0, 0, 0, 0.04);
  box-shadow: 0 4px 13px 0 rgba(0, 0, 0, 0.06);
  cursor: pointer;
  height: 100%;
  padding: 13px;
}

.activeVariant {
  border: 2px solid var(--purple);
  padding: 12px;
}

.imageWrapper {
  height: var(--pvsi-image-size);
  margin: 0 auto;
  width: var(--pvsi-image-size);
}

.picture {
  height: 100%;
}

.image {
  height: 100%;
  object-fit: contain;
  width: 100%;
}

.name {
  margin-top: 8px;
  font-family: var(--roboto-condensed);
  font-size: to-rem(17px);
  font-weight: bold;
  text-align: center;
  min-height: 2.5em;
}
</style>
